export default __webpack_public_path__ + "static/SRF 1140S - Fiche de spécifications et données techniques-d9d99b6b5a4e30d3e518ba6657174638.pdf";